import { API } from "../../utils/_HttpUtils";
import { admin_routes as routes } from "../../constants/api-routes";

const userPermissionsList = () =>
    new API().send("POST", routes.userPermissions).then((response) => {
        return Promise.resolve(response.data);
    });

export { userPermissionsList };
